import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { SimpleClubProgram } from '../store';

@Injectable()
export class LeftNavigationService {

  private subject = new Subject<Object>();
  public selectedTeamBillingProgram: SimpleClubProgram;

  constructor(
  ) {
  }

  setLeftNav(ProgramId, ProgramTypeId, ProgramName, ProgramStatus) {
    const obj = {
      'ProgramId': ProgramId,
      'ProgramTypeId': ProgramTypeId,
      'ProgramName': ProgramName,
      'ProgramStatus': ProgramStatus
    };
    this.subject.next(obj);
  }

  getLeftNav(): Observable<Object> {
    return this.subject.asObservable();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/left-navigation.service.ts